import React, { Suspense, useEffect, lazy } from 'react';
import { get } from '../../helpers/settings';

import { SpinnerElement } from '../spinner';
const ReCAPTCHA = lazy(() => import('react-google-recaptcha'));

interface ReCaptchaProps {
  onChange: (v: string | null) => void;
  className?: string;
}

const ReCaptcha = ({ onChange, className }: ReCaptchaProps) => {
  useEffect(() => {
    if (!process.env.SSR) {
      window.recaptchaOptions = {
        lang: 'sv',
      };
    }
  }, []);

  return (
    <div className={className}>
      <Suspense fallback={<SpinnerElement modifiers="inverted" />}>
        <ReCAPTCHA
          sitekey={get('GoogleCaptchaKey')}
          onChange={onChange}
          className="l-inline-block valign-top"
        />
      </Suspense>
    </div>
  );
};

export default ReCaptcha;
